import { render, staticRenderFns } from "./TownOverview.vue?vue&type=template&id=3e496668&scoped=true&"
import script from "./TownOverview.vue?vue&type=script&lang=js&"
export * from "./TownOverview.vue?vue&type=script&lang=js&"
import style0 from "./TownOverview.vue?vue&type=style&index=0&id=3e496668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e496668",
  null
  
)

export default component.exports